import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderTabs } from './type';

type Props = {
    activeTab: HeaderTabs;
};

const ConfiguratorModuleFooter = ({ activeTab }: Props) => {
    const { t } = useTranslation(['configuratorModuleDetail']);

    if (activeTab !== HeaderTabs.MainDetails) {
        return null;
    }

    return (
        <Button form="updateForm" htmlType="submit" type="primary">
            {t('configuratorModuleDetail:mainActionButtons.update')}
        </Button>
    );
};

export default ConfiguratorModuleFooter;
